/**
 * Manual AdSense display units only (no Auto ads).
 * All REACT_APP_ADSENSE_* values are build-time (CRA); unset = ads fully hidden.
 *
 * Note: CRA only inlines env vars referenced as static process.env.REACT_APP_* strings.
 */

export function getAdSenseClient() {
  const client = (process.env.REACT_APP_ADSENSE_CLIENT || "").trim();
  return client || null;
}

/** True when a publisher client id is configured (script may load; slots still need their own env). */
export function isAdsEnabled() {
  return Boolean(getAdSenseClient());
}

const SLOTS = {
  FOOTER: process.env.REACT_APP_ADSENSE_SLOT_FOOTER,
  NEWS: process.env.REACT_APP_ADSENSE_SLOT_NEWS,
};

/** @param {"FOOTER"|"NEWS"|string} name */
export function getAdSenseSlot(name) {
  if (!name) return null;
  const raw = SLOTS[String(name).toUpperCase()];
  const slot = (raw || "").trim();
  return slot || null;
}

let scriptRequested = false;

function hasAdSenseScript(client) {
  if (document.querySelector(`script[data-adsense-client="${client}"]`)) {
    return true;
  }
  // Head verification snippet may omit data-adsense-client; match by src.
  const scripts = document.querySelectorAll(
    'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]',
  );
  for (const el of scripts) {
    const src = el.getAttribute("src") || "";
    if (src.includes(`client=${client}`) || src.includes(`client=${encodeURIComponent(client)}`)) {
      return true;
    }
  }
  return false;
}

/**
 * Ensure AdSense script is present once. Does not enable Auto ads.
 * No-ops if index.html (or a prior call) already loaded the same client.
 */
export function ensureAdSenseScript(client) {
  if (typeof document === "undefined" || !client || scriptRequested) return;
  if (hasAdSenseScript(client)) {
    scriptRequested = true;
    return;
  }
  scriptRequested = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
  s.crossOrigin = "anonymous";
  s.dataset.adsenseClient = client;
  document.head.appendChild(s);
}
